import { dichVuThanhToanApi } from "../../../api/dich-vu/dichVuThanhToanApi";
import { hoaDonDienTuApi } from "../../../api/hoa-don/hoaDonDienTuApi";
import { IPhatHanhDichVuMultipleRequest } from "../../../model/request/hoa-don-dien-tu/IPhatHanhDichVuMultipleRequest";
import { IDichVuThanhToan } from "../../../model/respone/dich-vu/IDichVuThanhToan";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import {
  eDichVuThanhToanActionIds,
  IDichVuThanhToanActionTypes,
} from "../../action-types/dich-vu/IDichVuThanhToanActions";
import { rootActions } from "../../actions/rootActions";

import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

export function* dichVuThanhToanSaga(): any {
  yield takeLatest(eDichVuThanhToanActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDichVuThanhToanActionIds.SAVE_START, saveWorker);
  yield takeEvery(eDichVuThanhToanActionIds.DELETE_START, deleteWorker);
  yield takeEvery(
    eDichVuThanhToanActionIds.PHAT_HANH_HOA_DON_START,
    phatHanhHoaDonWorker
  );
  yield takeEvery(
    eDichVuThanhToanActionIds.DONG_BO_HOA_DON_STATUS_START,
    dongBoTrangThaiHoaDonWorker
  );
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(dichVuThanhToanApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.dichVu.thanhToan.LOAD_SUCCESS(res.data));
  } else {
    yield put(rootActions.dichVu.thanhToan.LOAD_ERRR(res.message ?? "Có lỗi"));
  }
}

function* saveWorker(action: IDichVuThanhToanActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IDichVuThanhToan;
  if (payload.id > 0) {
    res = yield call(dichVuThanhToanApi.Update, payload);
  } else {
    res = yield call(dichVuThanhToanApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.dichVu.thanhToan.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.dichVu.thanhToan.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* deleteWorker(action: IDichVuThanhToanActionTypes): any {
  const res: IBaseRespone = yield call(
    dichVuThanhToanApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.dichVu.thanhToan.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.dichVu.thanhToan.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* phatHanhHoaDonWorker(action: IDichVuThanhToanActionTypes): any {
  var request = action.payload as IPhatHanhDichVuMultipleRequest;
  const res: IBaseRespone = yield call(
    hoaDonDienTuApi.PhatHanhDichVuMultiple,
    request
  );
  if (res.is_success) {
    yield put(
      rootActions.dichVu.thanhToan.PHAT_HANH_HOA_DON_SUCCESS(undefined)
    );
    yield put(
      rootActions.dichVu.hoSo.LOAD_START(
        request.ho_sos?.[0]?.thanh_toan?.id_thong_tin_dv ?? 0
      )
    );
  } else {
    yield put(
      rootActions.dichVu.thanhToan.PHAT_HANH_HOA_DON_ERROR(
        res.message ?? "Có lỗi"
      )
    );
  }
}

function* dongBoTrangThaiHoaDonWorker(
  action: IDichVuThanhToanActionTypes
): any {
  var request = action.payload as IPhatHanhDichVuMultipleRequest;
  const res: IBaseRespone = yield call(
    hoaDonDienTuApi.DongBoDichVuMultiple,
    request
  );
  if (res.is_success) {
    yield put(
      rootActions.dichVu.thanhToan.DONG_BO_HOA_DON_STATUS_SUCCESS(undefined)
    );
    yield put(
      rootActions.dichVu.hoSo.LOAD_START(
        request.ho_sos?.[0]?.thanh_toan?.id_thong_tin_dv ?? 0
      )
    );
  } else {
    yield put(
      rootActions.dichVu.thanhToan.PHAT_HANH_HOA_DON_ERROR(
        res.message ?? "Có lỗi"
      )
    );
  }
}
